import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, AfterViewInit, ViewChild, ElementRef, inject } from '@angular/core';
import { fromEvent } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-hero-image',
    templateUrl: './hero-image.component.html',
    styleUrls: ['./hero-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
})
export class HeroImageComponent implements AfterViewInit {
    private cdref = inject(ChangeDetectorRef);

    @Input({ required: true }) src!: string;
    @Input() showLogo = false;
    @ViewChild('logo') logo!: ElementRef;

    isLoaded = false;
    ngAfterViewInit(): void {
        const event = fromEvent(this.logo?.nativeElement, 'load');
        event
            .pipe(
                tap(() => {
                    this.isLoaded = true;
                    this.cdref.detectChanges();
                }),
            )
            .subscribe();
    }
}
